export default __webpack_public_path__ + "static/media/logo.afa96769.png";